import LCHColor from '../classes/lch-color';

const lab2lch = ({ lightness: l, a, b, alpha }) => {
  const c = Math.sqrt(a ** 2 + b ** 2);
  const h = ((180 * Math.atan2(b, a)) / Math.PI + 360) % 360;
  return new LCHColor(l, c, h, alpha);
};

export default lab2lch;
